import { API } from 'core/api';
import { useState, useEffect } from 'react';
import { usePartner } from 'shared/hooks';
import { StripeReportData } from './types';

const ERROR_MESSAGE = "Couldn't fetch the report";
const useStripeReport = ({ status }: { status: string }) => {
  const [data, setData] = useState<StripeReportData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const partner = usePartner();

  useEffect(() => {
    const fetchPaymentPortal = async () => {
      try {
        if (partner?.partnerId) {
          setLoading(true);
          const { data } = await API.getStripeReportData({
            partnerId: partner?.partnerId?.toString() || '',
            status,
          });

          setData(data?.data || []);
          setLoading(false);
        }
      } catch (error) {
        setError(ERROR_MESSAGE);
        setLoading(false);
      }
    };

    fetchPaymentPortal();
  }, [status, partner?.partnerId]);

  return { data, loading, error };
};

export default useStripeReport;
